import React from "react";
import { cn } from "@/lib/utils";

export const PricingToggle = ({
  billingCycle,
  onChange,
}: {
  billingCycle: "monthly" | "yearly";
  onChange: (b: "monthly" | "yearly") => void;
}) => {
  return (
    <div className="inline-flex bg-muted p-1 rounded-full text-sm font-medium">
      <button
        className={cn(
          "px-4 py-2 rounded-full transition",
          billingCycle === "monthly"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onChange("monthly")}
      >
        Monthly
      </button>

      <button
        className={cn(
          "px-4 py-2 rounded-full transition flex items-center",
          billingCycle === "yearly"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
        onClick={() => onChange("yearly")}
      >
        Yearly
        <span className="ml-2 text-primary bg-primary/10 text-xs px-2 py-0.5 rounded-full font-medium">
          Save 40%
        </span>
      </button>
    </div>
  );
};
